import React from "react";
import OrganizationPage from "./Pages/OrganizationPage";
import Dashboard from "./components/Dashboard/Dashboard";
import Alerts from "./components/Alerts/Alerts";
import Profiles from "./components/Profiles/Profiles";
import Performance from "./components/Performance/Performance";
import Activity from "./components/Activity/Activity";
import Resource from "./components/Resource/Resource";

const AppRoutes = [
  {
    key: "organization",
    path: "/Organization",
    element: <OrganizationPage />,
  },
  {
    key: "dashboard",
    path: "/Dashboard",
    element: <Dashboard />,
  },
  {
    key: "profiles",
    path: "/Profiles",
    element: <Profiles />,
  },
  {
    key: "performance",
    path: "Performance",
    element: <Performance />,
  },
  {
    key: "alerts",
    path: "Alerts",
    element: <Alerts />,
  },
  {
    key: "actiivty",
    path: "Actiivty",
    element: <Activity />,
  },
  {
    key: "resource",
    path: "Resource",
    element: <Resource />,
  },
];

export default AppRoutes;
